﻿import { LiveDataSetStation, LiveDataSetValue, Status } from "../API/LiveData/LiveDataSet";
import { DefaultParameterDefinitions } from "../DefaultParameterDefinitions";
import { MainSite } from "../MainSite";
import { WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../ParameterGroupInfoSet";
import { IStationValueFormatter, IStationValueObject } from "./IStationValueFormatter";

export class WindVariationFormatter implements IStationValueFormatter {

    constructor() {
    }

    public getShortName(): string {
        return "Wind Var";
    }

    public getUnits(): string {
        return null;
    }

    public getParameterGroupInfo(): ParameterGroupInfo {
        return ParameterGroupInfoSet.WindDirection_Backed_deg;
    }

    public getDescription(): string {
        return "Wind Variation in METAR coding format.";
    }

    public getId(): string {
        return null;
    }

    public getSensorId(): string | undefined {
        return undefined;
    }

    public plottable(): boolean {
        return false;
    }

    public axisMin(): number {
        return null;
    }

    public axisMax(): number {
        return null;
    }

    public plotLines(): boolean {
        return false;
    }

    public format(liveDataSetStation: LiveDataSetStation, warningRules?: WarningGroup): IStationValueObject {

        // the default if parameter has never existed
        var valueObject: IStationValueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Timestamp: null,
            Sensor: null
        }

        if (ParameterGroupInfoSet.WindDirection_Backed_deg.Id in liveDataSetStation.GroupValues && ParameterGroupInfoSet.WindDirection_Veered_deg.Id in liveDataSetStation.GroupValues) {

            var backed: LiveDataSetValue = liveDataSetStation.GroupValues[ParameterGroupInfoSet.WindDirection_Backed_deg.Id][0];
            var veered: LiveDataSetValue = liveDataSetStation.GroupValues[ParameterGroupInfoSet.WindDirection_Veered_deg.Id][0];

            var worstStatus: Status = Math.max(backed.ExpiryStatus, veered.ExpiryStatus);

            var paramDef = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id]
                .Sensors[backed.Sensor]
                .Parameters[backed.Parameter]
                .Variants[0]
                .ParameterDefinition;
            if ((!paramDef || paramDef.Default) && backed.Parameter in DefaultParameterDefinitions.Parameters) {
                paramDef = DefaultParameterDefinitions.Parameters[backed.Parameter];
            }

            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: worstStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: backed.Timestamp > veered.Timestamp ? backed.Timestamp : veered.Timestamp,
                Sensor: backed.Timestamp > veered.Timestamp ? backed.Sensor : veered.Sensor
            }

            if (typeof backed.Value == 'number' && typeof veered.Value == 'number' && (worstStatus == Status.Good || worstStatus == Status.Expiring)) {
                valueObject.Value = sprintf('%03.0f', backed.Value) + 'V' + sprintf('%03.0f', veered.Value);
            }
        }

        return valueObject;
    }
}